import { call, put } from "redux-saga/effects";
import { takeLatest } from "redux-saga/effects";
import { ACTIONS, API_URL, sagaFunction, STORAGE } from "../_config";
import { CallApi } from "./api/callApi";

export function* loginAdmin(action: any): any {
  try {
    const resp = yield call(CallApi.POST, API_URL.AUTH.LOGIN, action.payload, false);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      const data = resp.data.data;
      // 2FA flow — OTP required, do NOT store token yet
      if (data.requires_2fa) {
        action && action.callbackSuccess && action.callbackSuccess(resp.data);
        return;
      }
      const { token, admin } = data;
      localStorage.setItem(STORAGE, token);
      yield put({
        type: ACTIONS.AUTH.LOGIN,
        payload: { user: admin, token },
      });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* verifyAdminOtp(action: any): any {
  try {
    const resp = yield call(CallApi.POST, API_URL.AUTH.VERIFY_OTP, action.payload, false);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      const { token, admin } = resp.data.data;
      localStorage.setItem(STORAGE, token);
      yield put({
        type: ACTIONS.AUTH.LOGIN,
        payload: { user: admin, token },
      });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* logoutAdmin(action: any): any {
  try {
    const resp = yield call(CallApi.POST, API_URL.AUTH.LOGOUT, {}, true);
    localStorage.removeItem(STORAGE);
    yield put({ type: ACTIONS.AUTH.LOGOUT });
    if (resp && resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackSuccess && action.callbackSuccess({});
    }
  } catch (e: any) {
    localStorage.removeItem(STORAGE);
    yield put({ type: ACTIONS.AUTH.LOGOUT });
    action && action.callbackSuccess && action.callbackSuccess({});
  }
}

export function* getAdminProfile(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.AUTH.PROFILE, action.payload, true, [
    { type: ACTIONS.AUTH.ME, payload: "admin" },
  ]);
}

export function* updateAdminProfile(action: any): any {
  try {
    const resp = yield call(CallApi.POST, API_URL.AUTH.UPDATE_PROFILE, action.payload, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      // Show success message from update response
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
      
      // Fetch full profile to update Redux with complete user data (including admin_role, menu_permissions)
      const profileResp = yield call(CallApi.GET, API_URL.AUTH.PROFILE, null, true);
      if (profileResp.status >= 200 && profileResp.status < 300 && profileResp.data && profileResp.data.data) {
        yield put({
          type: ACTIONS.AUTH.ME,
          payload: profileResp.data.data.admin,
        });
      }
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* changeAdminPassword(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.AUTH.CHANGE_PASSWORD, action.payload, true);
}

export function* toggleAdmin2FA(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.AUTH.TOGGLE_2FA, action.payload, true);
}

export function* resendAdminOtp(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.AUTH.RESEND_OTP, action.payload, false);
}

import { SAGA_ACTIONS } from "../_config";

export default function* adminAuthSaga() {
  yield takeLatest(SAGA_ACTIONS.ADMIN.AUTH.LOGIN, loginAdmin);
  yield takeLatest(SAGA_ACTIONS.ADMIN.AUTH.VERIFY_OTP, verifyAdminOtp);
  yield takeLatest(SAGA_ACTIONS.ADMIN.AUTH.RESEND_OTP, resendAdminOtp);
  yield takeLatest(SAGA_ACTIONS.ADMIN.AUTH.LOGOUT, logoutAdmin);
  yield takeLatest(SAGA_ACTIONS.ADMIN.AUTH.GET_PROFILE, getAdminProfile);
  yield takeLatest(SAGA_ACTIONS.ADMIN.AUTH.UPDATE_PROFILE, updateAdminProfile);
  yield takeLatest(SAGA_ACTIONS.ADMIN.AUTH.CHANGE_PASSWORD, changeAdminPassword);
  yield takeLatest(SAGA_ACTIONS.ADMIN.AUTH.TOGGLE_2FA, toggleAdmin2FA);
}
